// @flow
import React from 'react'
import { VerticalCol, VerticalRow } from '../utils/Grid'
import WidgetContainer from '../containers/WidgetContainer'
import GamesBox from '../boxes/GamesBox'
import utmLinkGenerator from '../utils/UTMLinkGenerator'
import { type GamesWidgetProps } from './Types'
import { sendEvent } from '../utils/googleAnalytics'

declare var UNVERSIONED_STATICS_PATH: string

export default (props: GamesWidgetProps) => {
  const {
    isOpening,
    widget,
    googleAnalytics,
    widget: {
      boxes,
      imageSize = '4_3',
      utmMedium
    }
  } = props

  if (!boxes.length) {
    return null
  }

  const handleAnchorClick = ({ url, position }) => () =>
    sendEvent(googleAnalytics, {
      category: 'Article',
      action: widget.name,
      label: url,
      pozice: position
    })

  return (
    <WidgetContainer googleAnalytics={googleAnalytics} widget={widget} isOpening={isOpening}>
      <VerticalRow>
        {
          boxes.map((box, index) => {
            const {
              guid,
              images,
              link,
              source,
              title
            } = box

            const image = `${UNVERSIONED_STATICS_PATH}${images[imageSize]}`

            const utmLink = utmLinkGenerator.createLink(link, {
              utmMedium,
              utmTerm: `position-${boxes.indexOf(box)}`,
              utmCampaign: source
            })

            return (
              <VerticalCol key={guid}>
                <GamesBox
                  image={image}
                  imageClass={`image-${imageSize}`}
                  link={utmLink}
                  title={title}
                  handleAnchorClick={handleAnchorClick({ url: box.link, position: index + 1 })}
                />
              </VerticalCol>
            )
          })
        }
      </VerticalRow>
    </WidgetContainer>
  )
}
